<template>
  <li class="px-4 sm:px-0">
    <FieldItemTypeLinkDescription
      :link-title="normalizedLinkItem?.linkTitle"
      :uri="normalizedLinkItem?.uri"
      :link-media="linkMedia"
    />
  </li>
</template>

<script lang="ts" setup>
import type { ParagraphLinkFragment } from '#graphql-operations'

defineBlokkli({
  bundle: 'link',
  editor: {
    editTitle: (el) => el.querySelector('a')?.innerText,
  },
})

const props = defineProps<{
  linkMedia?: ParagraphLinkFragment['linkMedia']
  linkItem: ParagraphLinkFragment['linkItem']
}>()

const normalizedLinkItem = computed(() => {
  // If linkItem is an array, take the first item, otherwise use it directly
  return Array.isArray(props.linkItem) ? props.linkItem[0] : props.linkItem
})

defineOptions({
  name: 'ParagraphLink',
})
</script>
